import { useCallback } from 'react'
import { ReferencedEntityWithIcon } from '../../../../domain/value-object/ReferencedEntity'
import { useWbsItemRepository } from '../../../../services/adaptors/wbsItemRepositoryAdaptor'
import { ROOT_WBS_ITEM_TYPES } from '../wbsItemSearch'

const CACHE_TTL_MS = 60_000

type CacheEntry = {
  promise: Promise<ReferencedEntityWithIcon[]>
  expiresAt: number
}

// 検索条件ダイアログの初回オープン・保存条件適用・画面初期化時の復元処理など、
// 同一プロジェクトに対して短時間に複数経路から呼ばれるWBS全件取得APIをまとめるための
// プロセス共有キャッシュ。in-flight Promise をそのまま再利用するため、並行リクエストも
// 1回にまとまる。失敗したエントリは破棄して次回の再試行を可能にする。
const cache = new Map<string, CacheEntry>()

export const useRootWbsItems = (
  projectUuid: string
): (() => Promise<ReferencedEntityWithIcon[]>) => {
  const { fetchListAsReferencedEntity } = useWbsItemRepository()

  return useCallback(() => {
    const now = Date.now()
    const cached = cache.get(projectUuid)
    if (cached && cached.expiresAt > now) {
      return cached.promise
    }
    const promise = fetchListAsReferencedEntity(
      projectUuid,
      ROOT_WBS_ITEM_TYPES
    ).catch(error => {
      if (cache.get(projectUuid)?.promise === promise) {
        cache.delete(projectUuid)
      }
      throw error
    })
    cache.set(projectUuid, {
      promise,
      expiresAt: now + CACHE_TTL_MS,
    })
    return promise
  }, [projectUuid, fetchListAsReferencedEntity])
}
